import Sidebar from "./Sidebar";
import "../assets/css/Layout.css";

function Layout({ children, activePage, onLogout }) {
  return (
    <div className="layout-container">
      <Sidebar activePage={activePage} onLogout={onLogout} />
      <main className="main-content">{children}</main>
    </div>
  );
}

export default Layout;
